import { render } from "./DocumentReader.vue?vue&type=template&id=4634dd8e&scoped=true"
import script from "./DocumentReader.vue?vue&type=script&lang=js"
export * from "./DocumentReader.vue?vue&type=script&lang=js"

import "./DocumentReader.vue?vue&type=style&index=0&id=4634dd8e&scoped=true&lang=scss"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4634dd8e"]])

export default __exports__